<lib-page-heading text="Firm Details"></lib-page-heading>
<div class="row mb-4">
    <div class="col-6 offset-3">
        <lib-firm-details
            (save)="router.navigateByUrl(['/'])"
            (requestForbidden)="location.back()"
        ></lib-firm-details>
    </div>
</div>
